<template>
  <div class="modal fade" id="sncrBalanceModal" tabindex="-1" aria-labelledby="sncrBalanceModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h5 class="modal-title" id="sncrBalanceModalLabel">
              <i class="bi bi-shield-check me-2 text-primary"></i>
              Numerações da Anvisa
            </h5>
            <span class="text-muted fs-7">Estoque disponível para emissão de receitas pelo SNCR</span>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <div class="modal-body">
          <div class="sncr-modal-tabs" role="tablist" aria-label="Informações sobre as numerações da Anvisa">
            <button type="button" :class="{active: activeTab === 'balance'}" role="tab"
                    :aria-selected="activeTab === 'balance'" @click="activeTab = 'balance'">
              <i class="bi bi-123"></i>
              Suas numerações
            </button>
            <button type="button" :class="{active: activeTab === 'guide'}" role="tab"
                    :aria-selected="activeTab === 'guide'" @click="activeTab = 'guide'">
              <i class="bi bi-journal-medical"></i>
              Como funciona
            </button>
          </div>

          <SncrSection v-show="activeTab === 'balance'" :professional-id="professionalId" compact/>

          <section v-show="activeTab === 'guide'" class="sncr-guide" role="tabpanel">
            <div class="sncr-guide-highlight">
              <i class="bi bi-shield-check"></i>
              <div>
                <strong>O SNCR centraliza a numeração nacional dos receituários controlados.</strong>
                <p>A Ubbimed solicita e consome esses números durante a emissão da receita eletrônica.</p>
              </div>
            </div>

            <div class="sncr-guide-grid">
              <article>
                <span class="sncr-guide-icon warning"><i class="bi bi-building"></i></span>
                <div>
                  <h6>Dependem da Vigilância Sanitária</h6>
                  <p>Notificações A, B e B2, retinoides sistêmicos e talidomida precisam de autorização e atribuição prévia de números pela Visa.</p>
                  <small>Entrar novamente no gov.br não aumenta esse saldo.</small>
                </div>
              </article>
              <article>
                <span class="sncr-guide-icon success"><i class="bi bi-lightning-charge"></i></span>
                <div>
                  <h6>Numeração automática</h6>
                  <p>Receitas de Controle Especial e receitas sujeitas à retenção eletrônicas recebem numeração automaticamente pelo SNCR.</p>
                </div>
              </article>
              <article>
                <span class="sncr-guide-icon primary"><i class="bi bi-qr-code"></i></span>
                <div>
                  <h6>Consulta e rastreabilidade</h6>
                  <p>O documento eletrônico usa o modelo oficial e leva um QR Code para consulta e validação no site da Anvisa.</p>
                </div>
              </article>
            </div>

            <h6 class="sncr-links-title">Materiais oficiais</h6>
            <div class="sncr-links">
              <a href="https://www.gov.br/anvisa/pt-br/assuntos/medicamentos/controlados/sncr" target="_blank" rel="noopener noreferrer">
                <span><strong>Portal do SNCR</strong><small>Anvisa · orientações, manuais e perguntas frequentes</small></span>
                <i class="bi bi-box-arrow-up-right"></i>
              </a>
              <a href="https://www.gov.br/anvisa/pt-br/assuntos/medicamentos/controlados/sncr/receituario-eletronico" target="_blank" rel="noopener noreferrer">
                <span><strong>Receituário eletrônico</strong><small>Anvisa · modelos oficiais e regras do QR Code</small></span>
                <i class="bi bi-box-arrow-up-right"></i>
              </a>
              <a href="https://portal.cfm.org.br/noticias/notificacoes-de-receitas-amarela-azul-e-outras-poderao-ser-emitidas-eletronicamente-a-partir-desta-quarta-feira-30/" target="_blank" rel="noopener noreferrer">
                <span><strong>Orientações para médicos</strong><small>CFM · mudanças na prescrição de controlados</small></span>
                <i class="bi bi-box-arrow-up-right"></i>
              </a>
              <a href="https://www.cremesp.org.br/index/library/modulos/flipbook/revista/104/resources/views/site_cid10_tabela.php?id=6883&amp;siteAcao=NoticiasC" target="_blank" rel="noopener noreferrer">
                <span><strong>Webinar sobre a RDC 1.000/2025</strong><small>Cremesp e CRF-SP · aplicação prática das novas regras</small></span>
                <i class="bi bi-box-arrow-up-right"></i>
              </a>
            </div>
          </section>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SncrSection from "./SncrSection.vue";

export default {
  name: "SncrModal",
  components: {SncrSection},
  props: {
    professionalId: {type: [Number, String], required: true},
  },
  data() {
    return {
      activeTab: 'balance',
    };
  },
}
</script>

<style scoped>
.sncr-modal-tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  margin-bottom: 20px;
  border-radius: 10px;
  background: #f3f4f6;
}

.sncr-modal-tabs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: 10px 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #667085;
  background: transparent;
  font-weight: 600;
}

.sncr-modal-tabs button.active {
  border-color: rgba(120, 15, 90, 0.15);
  color: #780f5a;
  background: #fff;
  box-shadow: 0 2px 6px rgba(120, 15, 90, 0.1);
}

.sncr-guide-highlight {
  display: flex;
  gap: 14px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid #d8e7ff;
  border-radius: 10px;
  color: #173b69;
  background: #eef5ff;
}

.sncr-guide-highlight > i {
  font-size: 24px;
}

.sncr-guide-highlight p,
.sncr-guide-grid p {
  margin: 4px 0 0;
  color: #475467;
}

.sncr-guide-grid {
  display: grid;
  gap: 12px;
}

.sncr-guide-grid article {
  display: flex;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
}

.sncr-guide-grid h6 {
  margin-bottom: 2px;
}

.sncr-guide-grid small {
  display: block;
  margin-top: 6px;
  color: #7a4f00;
  font-weight: 600;
}

.sncr-guide-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  font-size: 18px;
}

.sncr-guide-icon.warning { color: #8a5a00; background: #fff4d6; }
.sncr-guide-icon.success { color: #287d3c; background: #e9f7ed; }
.sncr-guide-icon.primary { color: #780f5a; background: #f8eaf4; }

.sncr-links-title {
  margin: 24px 0 10px;
}

.sncr-links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.sncr-links a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e4e7ec;
  border-radius: 9px;
  color: #344054;
  text-decoration: none;
}

.sncr-links a:hover {
  border-color: rgba(120, 15, 90, 0.3);
  color: #780f5a;
  background: #fff9fd;
}

.sncr-links span,
.sncr-links small {
  display: block;
}

.sncr-links small {
  margin-top: 2px;
  color: #667085;
}

@media (max-width: 575.98px) {
  .sncr-links {
    grid-template-columns: 1fr;
  }
}
</style>
